import React from 'react';

export const PageWrapper = ({children}) => {
  return (
    <div className="page-wrapper">
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js